import CvSectionTemplate from './CvSectionTemplate';

export default function CvCertificates() {
  return (
    <CvSectionTemplate
      currentId="check_6"
      description="Dodaj certyfikaty, licencje lub szkolenia, które potwierdzają Twoje kwalifikacje."
    />
  );
}
